<template>
    <div class="booking-wizard" :class="{'tw:border-1 tw:border-zinc-200 tw:rounded-xl': tw}">
        <p v-if="wizardStore.followUpId && wizardStore.followUpDetails && wizardStore.followUpDetails.description">{{ wizardStore.followUpDetails.description }}</p>
        <collapsible-step
            @toggle="toggleStep"
            :title="step1Title"
            :completedSteps="wizardStore.completedSteps"
            :enabledSteps="wizardStore.enabledSteps"
            :openStep="wizardStore.currentStep"
            :step="1">
            <step1></step1>
        </collapsible-step>

        <collapsible-step
            @toggle="toggleStep"
            :title="$t('2. Registrering og valg')"
            :completedSteps="wizardStore.completedSteps"
            :enabledSteps="wizardStore.enabledSteps"
            :openStep="wizardStore.currentStep"
            :step="2">
            <step2></step2>
        </collapsible-step>

        <collapsible-step
            @toggle="toggleStep" v-if="step4Exists"
            :title="$t('3. Ekstra deltakere')"
            :completedSteps="wizardStore.completedSteps"
            :enabledSteps="wizardStore.enabledSteps"
            :openStep="wizardStore.currentStep"
            :step="3">
            <step3></step3>
        </collapsible-step>

        <collapsible-step
            @toggle="toggleStep"
            :title="step5Title"
            :completedSteps="wizardStore.completedSteps"
            :enabledSteps="wizardStore.enabledSteps"
            :openStep="wizardStore.currentStep"
            :step="4">
            <step4
                v-if="!props.followUpId"
                :hasSwish="hasSwish"
                :hasNets="hasNets"
                :officeName="officeName"
                :brandingDomain="brandingDomain"
                :studentPageName="studentPageName"
            ></step4>
            <step4Followup v-if="props.followUpId">

            </step4Followup>
        </collapsible-step>
    </div>
</template>

<script setup>
    import {ref, computed} from 'vue';
    import step1 from "./wizard/step-1-user-select.vue";
    import step2 from "./wizard/step-2-register.vue";
    import step3 from "./wizard/step-3-add-users.vue";
    import step4 from "./wizard/step-4-complete-and-pay.vue";
    import step4Followup from "./wizard/step-4-followup.vue";
    import CollapsibleStep from "./wizard/CollapsibleStep.vue";
    import { useWizardStore } from "./wizard/wizardState.js";

    // Initialize the Pinia store
    const wizardStore = useWizardStore();
    
    const props = defineProps({
        tw: {
            type: Boolean,
            default: false,
        },
        packageId: {
            type: Number,
            default: null
        },
        courseId: {
            type: Number,
            default: null
        },
        classId: {
            type: Number,
            default: null
        },
        followUpId: {
            type: Number,
            default: null
        },
        freeSlots: {
            type: Number,
            default: 0
        },
        freeInterpreterSlots: {
            type: Number,
            default: 0
        },
        start: {
            type: Number,
            default: null
        },
        end: {
            type: Number,
            default: null
        },
        teacherId: {
            type: Number,
            default: null
        },
        productId: {
            type: Number,
            default: null
        },
        productType: {
            type: Number,
            default: null
        },
        isDeliverable: {
            type: Boolean,
            default: false
        },
        officeId: {
            type: Number,
            required: true,
        },
        nnidPlaceholder: {
            type: String,
            default: ''
        },
        yskLocationId: {
            type: Number,
            default: null
        },
        eventStartTime: {
            type: String,
            default: null,
        },
        hasSwish: {
            type: Boolean,
            default: false
        },
        hasNets: {
            type: Boolean,
            default: false
        },
        officeName: {
            type: String,
            default: ''
        },
        brandingDomain: {
            type: String,
            default: '',
        },
        studentPageName: {
            type: String,
            default: '',
        },
    });

    wizardStore.$reset();

    // Initialize store with props
    wizardStore.officeId = props.officeId;
    wizardStore.classId = props.classId;
    wizardStore.yskLocationId = props.yskLocationId;
    wizardStore.eventStartTime = props.eventStartTime;
    wizardStore.nnidPlaceholder = props.nnidPlaceholder;
    wizardStore.packageId = props.packageId;
    wizardStore.courseId = props.courseId;
    wizardStore.productId = props.productId;
    wizardStore.productType = props.productType;
    wizardStore.followUpId = props.followUpId;
    wizardStore.start = props.start;
    wizardStore.end = props.end;
    wizardStore.teacherId = props.teacherId;
    wizardStore.isDeliverable = props.isDeliverable;
    wizardStore.freeSlots = props.freeSlots;
    wizardStore.freeInterpreterSlots = props.freeInterpreterSlots;
    wizardStore.tw = props.tw;
    wizardStore.getTerms();

    const openStep = ref(1);
    const toggleStep = (step) => {
        openStep.value = step;
        wizardStore.currentStep = step;
    };

    const step1Title = computed(() => {
        if (props.followUpId) {
            return TABS.$t('1. Hvem melder du på?');
        }
        return TABS.$t('1. Hvem bestiller du for?');
    })
    const step4Exists = ref(props.courseId !== null);
    const step5Title = computed(() => {
        if (props.followUpId) {
            return TABS.$t('3. Vilkår');
        }
        if (props.courseId) {
            return TABS.$t('4. Vilkår og betaling');
        }
        return TABS.$t('3. Vilkår og betaling');
    });
</script>